import { Equipment } from '.prisma/client';
import { Injectable } from '@angular/core';
import { CreateHotToastRef, HotToastService } from '@ngneat/hot-toast';
import { of, Subject } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {
  createItemEffect,
  deleteItemEffect,
  loadListEffect,
  updateItemEffect,
} from '../../shared/crud/effects';
import {
  createItem,
  deleteItem,
  loadList,
  updateItem,
} from './equipment.actions';
import { EquipmentRepository } from './equipment.repository';
import { EquipmentService } from './equipment.service';

@Injectable({ providedIn: 'root' })
export class EquipmentEffects {
  public notify$ = new Subject<{
    action: { type: string };
    payload?: unknown;
  }>();

  constructor(
    private repository: EquipmentRepository,
    private service: EquipmentService,
    private toast: HotToastService
  ) {}

  loadEntities$ = loadListEffect<Equipment>({
    action: loadList,
    repository: this.repository,
    serviceAction: () => this.service.findAll(),
    toast: this.toast,
  });

  createEntity$ = createItemEffect<Equipment>({
    action: createItem,
    repository: this.repository,
    serviceAction: (entity) => this.service.create(entity),
    toast: this.toast,
  });

  updateEntity$ = updateItemEffect<Equipment>({
    action: updateItem,
    repository: this.repository,
    serviceAction: (id, changes) => this.service.update(id, changes),
    toast: this.toast,
  });

  deleteEntity$ = deleteItemEffect<Equipment>({
    action: deleteItem,
    repository: this.repository,
    serviceAction: (id) => this.service.delete(id),
    toast: this.toast,
  });

  loadEntityById$ = (id: Equipment['id']) => {
    let toaster: CreateHotToastRef<unknown>;
    return of(id).pipe(
      switchMap((id) => {
        this.repository.updateStatus('item', 'pending');
        environment?.production ||
          (toaster = this.toast.loading(`Загрузка оборудования`));
        return this.service.findOne(id).pipe(
          tap((equipment) => {
            if (!environment?.production) {
              this.toast.success(`Оборудование загружено`);
            }
            if (equipment) {
              this.repository.updateEntity(equipment.id, equipment);
            }
          }),
          finalize(() => {
            toaster?.close();
          })
        );
      })
    );
  };
}
